import "./Errorsummery.scss";

const fieldLabels: Record<string, string> = {
  firstName: "Given name",
  lastName: "Last name",
  email: "Work email",
  mobileNo: "Work mobile",
  designation: "Designation",
  profileImageLive: "Profile photo",
};

const ErrorSummary = ({ errors }: { errors: Record<string, string> }) => {
  const errorEntries = Object.entries(errors);
  if (!errorEntries.length) return null;

  return (
    <>
      <div className="error-summary">
        <div className="error-header">
          <span className="error-icon">!</span>
          <span>Errors in form!</span>
        </div>
        <div className="error-message">
          Please fix the following errors to submit the request
        </div>
      </div>
      <div>
        <ul className="error-list">
          {errorEntries.map(([field, message]) => (
            <li key={field}>
              {fieldLabels[field] || field} {message}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default ErrorSummary;
